module.exports = __webpack_public_path__ + "static/media/5ed79b6272f4e5e57a748780.0cbc10d1.png";